import React, { useEffect, useState } from "react";

export default function SelectedCategory(props) {

    const { selection, setSelection, cat } = props;
    const { name, id, availableFilters } = cat;
    const [localSelectedFilters, setLocalSelectedFilters] = useState([]);

    const addFilterToSelection = (e) => {
        if (localSelectedFilters.includes(e)) {

            var filters = localSelectedFilters.filter(item => item.groupId != e.groupId)
            var model = {
                categoryId: id,
                name: name,
                filters: filters
            }

            setLocalSelectedFilters(filters);
            setSelection(selection => [...selection, model])
        }
        else {
            var filters = [...localSelectedFilters, e];
            var model = {
                categoryId: id,
                name: name,
                filters: filters
            }

            var newSelection = selection.filter(x => x.categoryId != model.categoryId);

            setLocalSelectedFilters(filters);
            setSelection(selection => [...newSelection, model])
        }
    }

    return (
        <div className="selected-category" >
            <h3>{name}</h3>
            <form>
                {availableFilters && availableFilters.map((filter) => (
                    <label>
                        <span>{filter.groupName}</span>
                        <input name={filter.groupName} type="checkbox" checked={localSelectedFilters.includes(filter)} onChange={() => addFilterToSelection(filter)} />
                    </label>
                ))}
            </form>
        </div>
    );
}